<template>
  <div class="tourGuide">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="loadMoreList"
      >
      <!-- <div class="list-item-box" v-for="(lists,index) in list" :key="index" @click="goGuideDetail(lists)"> -->
        <div class="list-item-box" v-for="(lists,index) in list" :key="index">
        <div class="items-box">
          
          <!-- <img :src="lists.photoPath ? lists.photoPath : '../../assets/travelAgency/ic_bm_cy1.png'" alt class="poster-img" /> -->
          <img src="../../assets/travelAgency/ic_bm_cy1.png" alt class="poster-img" />
          <div class="info-box">
            <div class="name-box">
              <div class="username">{{lists.name}}</div>
              <div class="idenity" v-if="lists.certificate">
                <txtTag class="tag" :bgColor="'#fff'" :border="'#36B374'" :txtColor="'#36B374'" :domHieght="28">{{lists.certificate}}</txtTag>
              </div>
            </div>
            <div class="level-box">
              <div class="names">{{lists.guideTypeStr}}导游</div>
              <!-- <div class="stars">
                <van-rate
                  v-model="lists.guideLevel"
                  readonly
                  allow-half
                  size="8px"
                  gutter="2px"
                  color="#FF8C1A"
                  void-color="#eee"
                  void-icon="star"
                />
              </div> -->
            </div>
          </div>
        </div>
        <rline  v-if="index < list.length - 1"></rline>
      </div>
    </van-list>
  </div>
</template>
<script>
    import api from '../../service/modules/travel'
    import rline from './components/line'
    import txtTag from './components/txt-tag'
    export default {
        components: {
            rline,
            txtTag
        },

        data () {
            return {
                list: [],
                pagination: { total: 0, current_page: 0, page_size: 10 },
                finished: false,
                loading: false,
                travelId: ''
            };
        },

        computed: {},

        watch: {},

        methods: {
            // 跳转导游详情页
            goGuideDetail (items) {
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: `${this.globalApp.getSystemInfo().host}web/#/guide/info?guideId=${items.id}&isBlacklist=${items.isBlacklist}&isSupervise=${items.isSupervise}`,
                        isFullScreen: 0,
                        setTitle: '',
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            loadMoreList () {
                this.getList();
            },
            getList () {
                api.getGuideList({ p: parseInt(this.pagination.current_page) + 1, travelId: this.travelId }).then(res => {
                    if (res.ret === 0) {
                        this.pagination = res.data.pagination;
                        this.list = [...this.list, ...res.data.list];
                        this.loading = false;
                        if (
                            this.pagination.current_page >= Math.ceil(this.pagination.total / this.pagination.page_size)
                        ) {
                            this.finished = true;
                        }
                    }
                })
            }
        },

        mounted () {
            this.travelId = this.$route.query.id
        },
        created () {}
    }
</script>
<style scoped lang="less">
.tourGuide {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);
    .list-item-box{
      box-sizing: border-box;
      padding: 0 12px;
      background: #fff;
    }

    .items-box {
      box-sizing: border-box;
      padding: 16px 0;
      display: flex;
      align-items: center;
      background: #fff;

      .poster-img {
        width: 36px;
        height: 36px;
        margin-right: 12px;
        object-fit: cover;
      }

      .info-box {
        .name-box {
          height: 16px;
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          .username {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 16px;
            margin-right: 8px;
          }
          .idenity {
            display:flex;
            transform: scale(0.5);
            transform-origin: left center;
          }
        }
        .level-box {
          display: flex;
          align-items: center;

          .names {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 12px;
            margin-right: 4px;
          }
          .star {
            background: pink;
          }
        }
      }
    }
  }
</style>
